var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Función Global",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          pasoActivoIndex: _vm.pasoActivoIndex,
          entidad: "Función Global",
          estadoEntidad: _vm.estadoEntidad,
          inactivable: _vm.modificable,
          nombreEntidad: _vm.pasos.informacionGeneral.formState.entity
            ? _vm.pasos.informacionGeneral.formState.entity.nombre.value
            : "",
          mensajeInactivo: _vm.mensajeInactivo
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("InformacionGeneral", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: { funcionGlobal: _vm.funcionGlobal, edicion: true },
            on: { change: _vm.handleFormChange, setScript: _vm.handleScript }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.permiteContinuarConfirm,
          titulo: _vm.tituloPermiteContinuar,
          mensaje: _vm.mensajePermiteContinuar,
          items: _vm.itemsNoValidos,
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.permiteContinuarConfirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }